export const SALES_ADVISOR_EMPTY_COPY =
  'No strong sales opportunities found right now.'

export const SALES_ADVISOR_PRODUCT_TITLE = 'Sales opportunities'

export const SALES_ADVISOR_CTA = 'Find Sales Opportunities'

export const SALES_ADVISOR_CHECKLIST_HEADLINE =
  'Want to sell more to this customer?'

export const SALES_ADVISOR_CHECKLIST_BODY =
  "Let OMS analyse this customer's purchasing behaviour, your products and their business to find potential sales opportunities."

export const SALES_ADVISOR_CHECKLIST_CTA = SALES_ADVISOR_CTA

export const SALES_ADVISOR_RETRY_COPY =
  'Sales opportunities are temporarily unavailable. Please try again.'

export const PROVENANCE_LABELS = {
  oms: 'OMS data',
  public: 'Public information',
  inference: 'OMS suggestion',
}

export function provenanceLabel(kind) {
  return PROVENANCE_LABELS[kind] || 'OMS suggestion'
}

export function buildOpportunityEmailDraft({
  venueTitle,
  contactName,
  opportunity,
} = {}) {
  const title = opportunity?.title || 'an idea'
  const greetingName = contactName || 'there'
  const subject = `Idea for ${venueTitle || 'your venue'}: ${title}`
  const body = [
    `Hi ${greetingName},`,
    opportunity?.whatToDo,
    opportunity?.why ? `Why we thought of this: ${opportunity.why}` : null,
    'Happy to talk it through.',
  ]
    .filter(Boolean)
    .join('\n\n')

  return { subject, body }
}

export function buildOpportunityMailto({ to, subject, body } = {}) {
  const query = [
    subject ? `subject=${encodeURIComponent(subject)}` : '',
    body ? `body=${encodeURIComponent(body)}` : '',
  ]
    .filter(Boolean)
    .join('&')
  const address = String(to || '').trim()
  return `mailto:${address}${query ? `?${query}` : ''}`
}

export function openMailtoDraft({ to, subject, body } = {}) {
  const href = buildOpportunityMailto({ to, subject, body })
  const anchor = document.createElement('a')
  anchor.href = href
  anchor.rel = 'noopener noreferrer'
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  return href
}

export function formatRetrievedAt(value) {
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
